(() => {
  const form = document.getElementById('ZupperSupportForm');
  if (!form || form.dataset.returnReady) return;
  form.dataset.returnReady = 'true';
  const find = (selector) => form.querySelector(selector);
  const type = find('#SupportType');
  const reason = find('#ReturnReason');
  const components = find('#ReturnComponents');
  const fields = find('[data-return-fields]');
  const returnType = 'Return / Refund Request';
  const storageKey = 'zupper-support-submission';
  const evidence = {
    damage: 'We may request: product photos, outer shipping carton photos, a shipping label photo, and package condition photos.',
    wrong: 'We may request: a product photo, a model / product label photo, and a shipping label photo.',
    missing: 'We may request: a complete kit photo, a carrying case / packaging photo, and a photo showing the included items.',
    functional: 'We may request: a product / model label photo, photos of the affected area, and a 30-60 second video showing the issue, indicator lights, or abnormal behavior.'
  };
  const sync = () => {
    const isReturn = type.value === returnType;
    fields.hidden = !isReturn;
    fields.disabled = !isReturn;
    form.querySelectorAll('[data-required], [data-return-required]').forEach((input) => { input.required = isReturn; });
    form.querySelectorAll('[data-general-field]').forEach((field) => {
      field.hidden = isReturn;
      field.querySelectorAll('input').forEach((input) => { input.disabled = isReturn; });
    });
    find('[data-email-label]').textContent = isReturn ? 'Email used for the order *' : 'Email *';
    find('[data-order-label]').textContent = isReturn ? 'Order Number *' : 'Order Number';
    find('[data-model-label]').textContent = isReturn ? 'Product / Model *' : 'Product / Model';
    find('[data-body-label]').textContent = isReturn ? 'Describe the Return Request *' : 'Issue description *';
    find('[data-support-submit]').textContent = isReturn ? 'Submit Return Request' : 'Send Message';
    const missing = isReturn && components.value === 'No';
    find('[data-missing-field]').hidden = !missing;
    find('#ReturnMissing').disabled = !missing;
    const kind = reason.selectedOptions[0]?.dataset.evidence;
    find('[data-evidence-notice]').hidden = !isReturn || !kind;
    find('[data-evidence-guidance]').textContent = evidence[kind] || '';
    find('[data-customer-notice]').hidden = !isReturn || !reason.value || !!kind;
  };
  type.querySelector('option[value="Return / Refund Request"]').disabled = false;
  let submission;
  try { submission = JSON.parse(sessionStorage.getItem(storageKey)); } catch (_) { /* Storage may be unavailable. */ }
  const recent = submission && Date.now() - submission.time < 30 * 60 * 1000;
  const success = find('[data-support-success]');
  if (success && recent && submission.type === returnType) {
    find('[data-normal-success]').hidden = true;
    find('[data-return-success]').hidden = false;
  }
  if (find('[data-support-errors]') && recent) type.value = submission.type;
  [type, reason, components].forEach((control) => control.addEventListener('change', sync));
  window.addEventListener('pageshow', sync);
  sync();
  form.addEventListener('submit', () => {
    const order = find('#SupportOrder').value.trim();
    const model = find('#SupportModel').value.trim();
    find('[name="contact[internal_thread_reference]"]').value = type.value === returnType
      ? `Return Request - Order ${order} - ${model}` : `ZUPPER Support - ${type.value}`;
    try { sessionStorage.setItem(storageKey, JSON.stringify({ type: type.value, time: Date.now() })); } catch (_) { /* Native contact submission remains available. */ }
  });
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      document.documentElement.classList.toggle('zs-return-chat-clear', entries.some((entry) => entry.isIntersecting));
    });
    observer.observe(find('[data-support-submit]'));
  }
})();
